require("../layout");
require("slick-carousel");
require("@fancyapps/fancybox");

$("#other-model").find(".buttons .button").on("click", function () {
    let currentModel = $(this).closest(".model");

    currentModel.find(".buttons .button").removeClass("active");
    $(this).addClass("active");

    let image = $(this).data("item");

    currentModel.find(".images .image").removeClass("active");
    $(image).addClass("active");
});


$("#slide-importan-images").slick({
    arrows: false,
    dots: true,
    infinite: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
})

$("#in-gallery").find('.slide').slick({
    arrows: false,
    dots: true,
    infinite: true,
    autoplay: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 1,

            }
        },
        {
            breakpoint: 575,
            settings: {
                slidesToShow: 1,
            }
        }
    ]
})

require("../componentes/recorrido_virtual");
require("../componentes/botones_flotantes");
require("../componentes/proyecto/modal_promotion");
require("../componentes/proyecto/banner_promocion_04_24");
